export default __webpack_public_path__ + "static/media/family-3-stock.60a36462.jpg";